const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.svg"
    height={50}
    {...props}
  />
);

export default Logo;
